import { render, staticRenderFns } from "./commonConfig_org.vue?vue&type=template&id=9c4d2c68"
import script from "./commonConfig_org.vue?vue&type=script&lang=js"
export * from "./commonConfig_org.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports